import React from 'react';
import Tetris from './components/Tetris';

function App () {
    return (
    <div className='App'>
        <Tetris />
    </div>
    );
}

export default App;